import {
  Checkbox,
  FormControlLabel,
  ListSubheader,
  Switch,
  TextField,
} from "@mui/material";
import SearchInput, {
  type SearchInputProps,
} from "src/components/input/SearchInput/SearchInput";
import { SELECTED_ONLY_SWITCH_MIN_TAGS } from "../../AssetsFilterTags.constants";
import type { TagSearchHeaderProps } from "../../AssetsFilterTags.types";

export default function TagSearchHeader({
  searchText,
  onSearchChange,
  selectedCount,
  onClearAll,
  tagsCount,
  showSelectedOnly,
  onShowSelectedOnlyChange,
}: TagSearchHeaderProps) {
  const showSelectedOnlySwitch =
    tagsCount > SELECTED_ONLY_SWITCH_MIN_TAGS && selectedCount > 0;

  return (
    <ListSubheader sx={{ top: 0, paddingTop: 1 }}>
      <TextField
        size="small"
        autoFocus
        placeholder="Type to search tags…"
        fullWidth
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== "Escape") {
            e.stopPropagation();
          }
        }}
        slots={{
          input: SearchInput,
        }}
        slotProps={{
          input: {
            size: "full",
          } satisfies SearchInputProps as any,
        }}
      />
      {selectedCount > 0 && (
        <div className="flex items-center justify-between gap-2">
          {showSelectedOnlySwitch && (
            <FormControlLabel
              className="select-none"
              onClick={(e) => e.stopPropagation()}
              onChange={(_, checked) => {
                onShowSelectedOnlyChange(checked);
              }}
              control={<Switch size="small" checked={showSelectedOnly} />}
              label="Selected only"
              sx={{ ml: 0 }}
            />
          )}
          <FormControlLabel
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onClearAll();
            }}
            control={<Checkbox size="small" indeterminate />}
            label={`${selectedCount} selected`}
            sx={{ mr: 0 }}
          />
        </div>
      )}
    </ListSubheader>
  );
}
